import { Box, Paper, Skeleton, Typography } from '@/shared/ui';

import generateSkeletonKeys from '@/shared/lib/format/generateSkeletonKeys';

const skeletonKeys = generateSkeletonKeys(30);
const CatalogSkeleton = () => (
  <Box data-testid='catalog-skeleton'>
    <Typography sx={{ my: 5 }}>Loading your data, please wait...</Typography>
    <Paper
      sx={{
        width: '100%',
        height: '100vh',
        p: 2,
        pt: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}
    >
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <Box sx={{ height: '100%' }}>
          {skeletonKeys.map(key => (
            <Skeleton
              key={key}
              height='23px'
              sx={{ my: 2 }}
              width='100%'
            />
          ))}
        </Box>
      </Box>
    </Paper>
  </Box>
);

export default CatalogSkeleton;
